module.exports = __webpack_public_path__ + "assets/img/kv_img-1.e5eb1a7e.png";